// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"52b62cce","99":"0f3bc903","332":"1b7c4298","503":"1727a72b","721":"7786b70c","734":"940381ed","906":"222c8b7d","940":"fb8abec0"}[chunkId] + ".chunk.css";
};